import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type IterationItemFragment = { __typename?: 'IterationItem', key: string, value: string, reason: string, description: string };

export type GetSynchronizationIterationsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.IterationDocumentFilterInput>;
  first: Types.Scalars['Int']['input'];
  order?: Types.InputMaybe<Array<Types.IterationDocumentSortInput> | Types.IterationDocumentSortInput>;
}>;


export type GetSynchronizationIterationsQuery = { __typename?: 'Query', synchronizationIterations?: { __typename?: 'SynchronizationIterationsConnection', totalCount: number, nodes?: Array<{ __typename?: 'IterationDocument', id: string, start: Types.TDateISO, end: Types.TDateISO, entity: Types.EntityType, description: string, totalMs: number, itemsProcessed: number, success: boolean, error: string, items: Array<{ __typename?: 'IterationItem', key: string, value: string, reason: string, description: string }>, skippedItems: Array<{ __typename?: 'IterationItem', key: string, value: string, reason: string, description: string }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetStagedItemsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ItemSummaryDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ItemSummaryDocumentSortInput> | Types.ItemSummaryDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetStagedItemsQuery = { __typename?: 'Query', stagedItems?: { __typename?: 'StagedItemsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ItemSummaryDocument', batchTracked: boolean, id: string, tenantId: string, itemId: string, name: string, sku: string, upc: string, retailPrice?: number | null, cogs?: number | null, status: Types.ItemStatus, description: string, categories?: Array<string> | null, sortCategory?: string | null, history: Array<string>, group: string, erpId: string, availableQuantity?: number | null, genus: string, productGroup: string, isOrganic: boolean, native: boolean, stripeTaxCode?: string | null, usageCount?: number | null, usedForRetail: boolean, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, defaultCarrier?: string | null, defaultShippingConfigCategoryCode?: string | null, shippingConfigCategoryCodes: Array<string>, effectiveShippingUomId?: string | null, inheritedShippingUomIds: Array<string>, availableShippingUomIds: Array<string>, shippingIncrement?: number | null, itemLookupCode: string, taxable: boolean, commissionable: boolean, discountable: boolean, effectiveEachesPerUnit?: number | null, effectiveShippingUomSource: Types.ShippingUomSource, characteristics: Array<{ __typename?: 'ItemCharacteristicPickDocument', itemCharacteristicId: string, valueId: string }>, sizes?: Array<{ __typename?: 'ItemDocumentSize', code: string, eaches: number, uom: number }> | null, substitution?: { __typename?: 'SubstitutionDocument', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfigDocument', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, containerConfigOverrides: Array<{ __typename?: 'ItemContainerConfigOverrideDocument', shippingConfigCategoryCode: string, sizeUomCode: string, containerCode: string, siteCode: string, maxTraysPerLayer?: number | null, maxLayersPerContainer?: number | null, shipFactor?: number | null, shipMinimum?: number | null }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export const IterationItemFragmentDoc = new TypedDocumentString(`
    fragment IterationItem on IterationItem {
  key
  value
  reason
  description
}
    `, {"fragmentName":"IterationItem"});
export const GetSynchronizationIterationsDocument = new TypedDocumentString(`
    query GetSynchronizationIterations($where: IterationDocumentFilterInput, $first: Int!, $order: [IterationDocumentSortInput!]) {
  synchronizationIterations(where: $where, first: $first, order: $order) {
    nodes {
      id
      start
      end
      entity
      description
      totalMs
      itemsProcessed
      success
      error
      items {
        ...IterationItem
      }
      skippedItems {
        ...IterationItem
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment IterationItem on IterationItem {
  key
  value
  reason
  description
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetStagedItemsDocument = new TypedDocumentString(`
    query GetStagedItems($where: ItemSummaryDocumentFilterInput, $order: [ItemSummaryDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  stagedItems(
    where: $where
    order: $order
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    nodes {
      ...ItemSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment ItemSummary on ItemSummaryDocument {
  batchTracked
  id
  tenantId
  itemId
  name
  sku
  upc
  retailPrice
  cogs
  status
  description
  categories
  sortCategory
  history
  group
  erpId
  availableQuantity
  genus
  productGroup
  isOrganic
  native
  characteristics {
    itemCharacteristicId
    valueId
  }
  stripeTaxCode
  usageCount
  usedForRetail
  sizes {
    code
    eaches
    uom
  }
  subcategory
  minShipQty
  loadFactor
  weightLbs
  lengthInches
  widthInches
  heightInches
  substitution {
    substitutionType
    value
  }
  royalty {
    ...RoyaltyConfigDocument
  }
  containerConfigIds
  containerConfigOverrides {
    shippingConfigCategoryCode
    sizeUomCode
    containerCode
    siteCode
    maxTraysPerLayer
    maxLayersPerContainer
    shipFactor
    shipMinimum
  }
  defaultCarrier
  defaultShippingConfigCategoryCode
  shippingConfigCategoryCodes
  effectiveShippingUomId
  inheritedShippingUomIds
  availableShippingUomIds
  shippingIncrement
  itemLookupCode
  usageCount
  taxable
  commissionable
  discountable
  effectiveEachesPerUnit
  effectiveShippingUomSource
}
fragment RoyaltyConfigDocument on RoyaltyConfigDocument {
  rateType
  rate
  payeeName
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetSynchronizationIterations: build.query<GetSynchronizationIterationsQuery, GetSynchronizationIterationsQueryVariables>({
      query: (variables) => ({ document: GetSynchronizationIterationsDocument, variables })
    }),
    GetStagedItems: build.query<GetStagedItemsQuery, GetStagedItemsQueryVariables | void>({
      query: (variables) => ({ document: GetStagedItemsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetSynchronizationIterationsQuery, useLazyGetSynchronizationIterationsQuery, useGetStagedItemsQuery, useLazyGetStagedItemsQuery } = injectedRtkApi;
